<section class="articles" [attr.aria-label]="translate.instant(title)">
    <header class="articles-header">
        <h2 class="articles-title" appLocalizationPopupDirective [localizationCode]="title">
            {{ translate.instant(title) }}
        </h2>

        <div class="nav-buttons" *ngIf="articles.length > 0 && (canScrollPrev || canScrollNext)">
            <button mat-icon-button class="nav-button" (click)="scrollCards(-1)" [disabled]="!canScrollPrev"
                [attr.aria-label]="'PreviousArticles' | translate: {Default: 'Previous articles'}">
                <mat-icon class="material-icons-outlined" aria-hidden="true">chevron_left</mat-icon>
            </button>
            <button mat-icon-button class="nav-button" (click)="scrollCards(1)" [disabled]="!canScrollNext"
                [attr.aria-label]="'NextArticles' | translate: {Default: 'Next articles'}">
                <mat-icon class="material-icons-outlined" aria-hidden="true">chevron_right</mat-icon>
            </button>
        </div>
    </header>

    <div *ngIf="isLoading && articles.length === 0" class="cards-track skeleton-track" role="status" aria-busy="true"
        [attr.aria-label]="'Loading articles' | translate: {Default: 'Loading articles'}">
        <div *ngFor="let _ of [1, 2, 3]" class="article-card skeleton-card" aria-hidden="true">
            <ngx-skeleton-loader count="1" [theme]="{ 'height.px': 160, 'margin': '0', 'border-radius': '0' }"></ngx-skeleton-loader>
            <div class="article-body">
                <ngx-skeleton-loader count="1" [theme]="{ 'height.px': 12, 'width.px': 90 }"></ngx-skeleton-loader>
                <ngx-skeleton-loader count="1" [theme]="{ 'height.px': 20, 'width': '80%' }"></ngx-skeleton-loader>
                <ngx-skeleton-loader count="2" [theme]="{ 'height.px': 14 }"></ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div *ngIf="articles.length > 0" #viewport class="cards-track" (scroll)="onViewportScroll()">
        <div *ngFor="let article of articles" class="article-card" [class.unread]="!isArticleRead(article)"
            role="button" tabindex="0" appPreventDoubleClick (throttledClick)="openArticleDialog(article)"
            [attr.aria-label]="article.title + ', ' + (article.lastEditedOn | date:'mediumDate') + (!isArticleRead(article) ? (', ' + ('Articles-New' | translate: {Default: 'New'})) : '')"
            (keydown.enter)="openArticleDialog(article)"
            (keydown.space)="$event.preventDefault(); openArticleDialog(article)">

            <div *ngIf="article.showImageOnSplashPage && article.titleImage" class="article-media">
                <ng-container *ngIf="getArticleImageUrl(article) | withLoading | async as articleImage">
                    <img *ngIf="articleImage.value" [src]="articleImage.value" alt="">
                    <div *ngIf="articleImage.error" class="media-placeholder" aria-hidden="true">
                        <mat-icon class="material-icons-outlined" aria-hidden="true">broken_image</mat-icon>
                    </div>
                    <ngx-skeleton-loader *ngIf="articleImage.loading" count="1" aria-hidden="true"
                        [theme]="{ 'height': '100%', 'margin': '0', 'border-radius': '0' }"></ngx-skeleton-loader>
                </ng-container>
            </div>

            <div class="article-body">
                <div class="article-meta">
                    <span class="article-date">{{ article.lastEditedOn | date:'mediumDate' }}</span>
                    <span *ngIf="!isArticleRead(article)" class="new-badge">
                        {{ 'Articles-New' | translate: {Default: "New"} }}
                    </span>
                </div>

                <h3 class="article-title" [matTooltip]="article.title" [matTooltipDisabled]="!isTitleTruncated"
                    (mouseenter)="isTitleTruncated = shouldShowTooltip($event)"
                    [matTooltipClass]="'no-ellipsis-tooltip'">{{ article.title }}</h3>

                <p class="article-splash" [class.expanded]="!article.showImageOnSplashPage || !article.titleImage">
                    {{ article.splashText }}
                </p>

                <span class="read-more" aria-hidden="true">
                    {{ 'Articles-ReadMore' | translate: {Default: "Read more"} }}
                    <mat-icon class="material-icons-outlined" aria-hidden="true">arrow_forward</mat-icon>
                </span>
            </div>
        </div>
    </div>

    <div *ngIf="!isLoading && articles.length === 0" class="empty-state" role="status">
        <mat-icon class="material-icons-outlined" aria-hidden="true">campaign</mat-icon>
        <p>{{ 'NoArticlesAvailable' | translate: {Default: "No articles available."} }}</p>
    </div>
</section>
